import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { forwardRef as F, useRef as s, useImperativeHandle as I } from "react";
import "dayjs";
import { useTranslation as x } from "react-i18next";
import { isArrayWithItems as R } from "../../../helpers/array-helper.js";
import "../../../contexts/global-context.js";
import "motion/react";
import { SecondaryButton as T } from "../../elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import c from "./file-upload.module.less.js";
import { InputElementTopSection as v } from "../components/input-element-top-section/input-element-top-section.js";
const C = F(
  ({ name: i, label: a, value: t, helperText: f, errorText: u, onChange: d, accept: h, isDisabled: l, allowMultipleFiles: b }, y) => {
    const { t: m } = x(), r = s(null), n = s(null);
    I(y, () => ({
      click() {
        r.current?.click();
      },
      focus() {
        n.current?.focus();
      }
    }), []);
    const N = () => {
      r && r.current?.click();
    };
    let o = "";
    return t instanceof File ? o = t.name : R(t) ? o = t.map((k, E) => /* @__PURE__ */ e("span", { children: k.name }, E)) : o = m("NO_FILE_SELECTED"), /* @__PURE__ */ p("div", { className: "space-mb-md", children: [
      /* @__PURE__ */ e(v, { label: a, helperText: f, errorText: u, htmlFor: i }),
      /* @__PURE__ */ p("div", { className: c.buttonWrapper, children: [
        /* @__PURE__ */ e(T, { ref: n, label: m("UPLOAD"), onClick: N, isDisabled: l }),
        /* @__PURE__ */ e("p", { className: `${c.fileName} body-s mb-0`, children: o })
      ] }),
      /* @__PURE__ */ e(
        "input",
        {
          ref: r,
          name: i,
          type: "file",
          hidden: !0,
          onChange: d,
          accept: h,
          multiple: b ? !0 : void 0,
          disabled: l ? !0 : void 0
        }
      )
    ] });
  }
);
C.displayName = "FileUpload";
export {
  C as default
};
